import messages from './cmsHomeCard.json' with { type: 'json' };

export const cmsHomeCardFi: Readonly<typeof messages> = messages;
